import { render, staticRenderFns } from "./TimeInOrgRenderer.vue?vue&type=template&id=53d20bd2&"
import script from "./TimeInOrgRenderer.vue?vue&type=script&lang=ts&"
export * from "./TimeInOrgRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports